import BG from "../../BG";
import Header from "../../Header";
import Body from "../../Body";
import Title from "../../Title";
import ButtonGroups from "../../ButtonGroups";
import Button from "../../Button";
import setCurrentPage from "src/Utils/setCurrentPage";
import UseCaseCard from "../../UseCaseCard";

interface TemplateProps {
  data: DataUseCases;
}

const Template = (props: TemplateProps) => {
  const {
    bgImage,
    title,
    back,
    actions,
    headerRightText,
    headerLeftImage,
    useCases,
  } = props.data;

  const templateType = "use-cases-template";

  return (
    <BG bgImage={bgImage}>
      <Header
        onClickHome={() => setCurrentPage("INTRO_0")}
        rightText={headerRightText}
        leftImage={headerLeftImage}
      />
      <Body>
        <div style={styles.container}>
          <Title
            style={{ marginTop: "32px" }}
            type={templateType}
            text={title}
          />
          <div style={{ flex: 1, display: "flex" }}>
            {useCases.map((useCase: UseCaseCardProps, index: number) => (
              <UseCaseCard
                text={useCase.text}
                title={useCase.title}
                subtitle={useCase.subtitle}
                button={useCase.button}
                image={useCase.image}
                imageStyle={useCase.imageStyle}
                key={index}
                type={templateType}
              />
            ))}
          </div>
          <div style={styles.bottom}>
            <div>{back !== null && <Button {...back} />}</div>
            <div>
              <ButtonGroups>
                {actions &&
                  actions.map((action, index) => (
                    <Button key={index} {...action} />
                  ))}
              </ButtonGroups>
            </div>
          </div>
        </div>
      </Body>
    </BG>
  );
};

const styles = {
  container: {
    display: "flex",
    height: "-webkit-fill-available",
    flexDirection: "column" as React.CSSProperties["flexDirection"],
  },
  bottom: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "45px",
  },
};

export default Template;
